'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // import css from 'cape-style'
// Action button.
// @TODO: Need a way to pass down some style to overwrite defaults.
// 'ba br1 p1 inlineBlock fs1 textReset bgTrans'


function LinkAction(_ref) {
  var action = _ref.action,
      children = _ref.children,
      style = _ref.style;
  return _react2.default.createElement('button', {
    onClick: action,
    style: style
  }, children);
}

LinkAction.propTypes = {
  action: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node.isRequired,
  style: _propTypes2.default.objectOf(_propTypes2.default.string)
};
LinkAction.defaultProps = {
  style: null
};
exports.default = LinkAction;
module.exports = exports['default'];